import trackEvent from '@99designs/utils/platform/trackEvent';
import trackLink from '@99designs/utils/platform/trackLink';
import { get } from 'common/utils/xhr';
import createScrollableElements, { centerAlignScrollableElement, scrollOnHover } from 'marketing/components/scrollable';
import { findParentByAttribute, getLinkTargetUrl, getLinkTargetPath } from 'common/utils/domUtils';
import FullscreenOverlay from 'marketing/components/FullscreenOverlay';

export default class LogoDesignInspiration {
    constructor() {
        this.allDesignsContainer = document.querySelector('[data-logo-inspiration-designs]');
        this.loading = document.querySelector('[data-logo-inspiration-designs-loading]');
        this.showAll = 'false';
        this.fullscreenOverlayElement = document.querySelector('[data-fullscreen-overlay-id="logo-design-inspiration-modal"]');

        this.initialise();
        this.getDesignsByIndustry();
        this.trackElementScrollLeft = this.trackElementScroll.bind(this, 'left');
        this.trackElementScrollRight = this.trackElementScroll.bind(this, 'right');
    }

    initialise() {
        let extraDesigns = document.querySelector('[data-extra-inspiration-designs]');
        let showMoreButton = document.querySelector('[data-extra-inspiration-button]');
        let discoverLink = document.querySelector('[data-extra-inspiration-discover-link]');
        let designs = this.allDesignsContainer.querySelectorAll('[data-fullscreen-overlay-open]');

        this.initialiseFullScreenOverlay();

        showMoreButton.addEventListener('click', () => {
            showMoreButton.setAttribute('data-hidden', true);
            extraDesigns.removeAttribute('data-hidden');
            discoverLink.removeAttribute('data-hidden');
            this.showAll = 'true';

            trackEvent('Clicked Element On Product Page', {
                element_id: 'inspiration-show-more-button',
                section_id: 'featured_contests_carousel',
                category: 'logo-design',
            });
        });

        for (const design of designs) {
            design.addEventListener('click', () => {
                this.setModalContent(design);

                trackEvent('Clicked Element On Product Page', {
                    element_id: 'design-card-list-item',
                    section_id: 'featured_contests_carousel',
                    category: 'logo-design',
                });
            });
        }
    }

    initialiseFullScreenOverlay() {
        new FullscreenOverlay({
            element: this.fullscreenOverlayElement,
            options: {
                fixedViewport: true
            }
        });
    }

    getDesignsByIndustry() {
        const industrySelect = document.getElementById('logo-design-inspiration-industry-select');


        industrySelect.addEventListener('change', (e) => {
            this.startLoading();

            trackEvent('Filtered By Industry On Product Page', {
                industry: e.target.value,
            });

            const xhr = get(`/start/xhr/inspiration-designs/${e.target.value}?show_all=${this.showAll}`);
            xhr.end((error, res) => {
                if (error) {
                    this.stopLoading();
                } else {
                    this.allDesignsContainer.innerHTML = res.body.html;
                    this.initialise();
                    this.runScrollable();
                    this.reattachTrackingEvents();
                    this.stopLoading();
                }
            });
        });
    }

    setModalContent(design) {
        const modalElement = this.fullscreenOverlayElement.querySelector('[data-fullscreen-overlay-modal-content]');
        const modalContentContainer = design.querySelector('[data-modal-content-container]');
        const modalImageElement = modalContentContainer.querySelector('[data-modal-image]');
        const modalImageSrc = modalImageElement.getAttribute('data-image-src');

        modalImageElement.setAttribute('src', modalImageSrc);
        modalElement.innerHTML = modalContentContainer.innerHTML;

        const designerProfileLink = modalElement.querySelector('[data-designer-profile-link]');
        const defaultData = Object.assign(global.trackParams, {
            section_id: 'featured_contests_carousel',
        });

        trackLink(designerProfileLink, 'Clicked Link On Product Page', Object.assign({}, defaultData, {
            target_url: getLinkTargetUrl(designerProfileLink),
            target_path: getLinkTargetPath(designerProfileLink)
        }));
    }

    startLoading() {
        this.loading.removeAttribute('data-hidden');
    }

    stopLoading() {
        this.loading.setAttribute('data-hidden', '');
    }

    reattachTrackingEvents() {
        this.setupTrackLink();
        this.setupScrollableTracking();
    }

    setupTrackLink() {
        let discoverLink = document.querySelector('[data-extra-inspiration-discover-link]');
        const defaultData = this.getDefaultTrackingData(discoverLink);
        const targetUrl = getLinkTargetUrl(discoverLink);
        const targetPath = getLinkTargetPath(discoverLink);

        trackLink(discoverLink, 'Clicked Link On Product Page', Object.assign({}, defaultData, {
            target_url: targetUrl,
            target_path: targetPath,
        }));
    }

    setupScrollableTracking() {
        const elements = document.querySelectorAll('[data-scrollable-inner]');

        Array.from(elements)
            .forEach(el => {
                el.addEventListener('scroll', this.trackElementScrollLeft);
                el.addEventListener('scroll', this.trackElementScrollRight);
            });
    }

    trackElementScroll(position, e) {
        const threshold = 300;
        const scrollLeft = e.target.scrollLeft;
        const scrollRange = e.target.scrollWidth - e.target.offsetWidth;
        const isLeftEdge = position === 'left' && scrollLeft <= 0 + threshold;
        const isRightEdge = position === 'right' && scrollLeft >= scrollRange - threshold;

        if (isLeftEdge) {
            const defaultData = this.getDefaultTrackingData(e.target);

            e.target.removeEventListener('scroll', this.trackElementScrollLeft);

            trackEvent('Scrolled Element To Side On Product Page', Object.assign({}, defaultData, {
                element_scroll_position: position,
            }));
        } else if (isRightEdge) {
            const defaultData = this.getDefaultTrackingData(e.target);

            e.target.removeEventListener('scroll', this.trackElementScrollRight);

            trackEvent('Scrolled Element To Side On Product Page', Object.assign({}, defaultData, {
                element_scroll_position: position,
            }));
        }
    }

    runScrollable() {
        createScrollableElements();
        scrollOnHover('[data-scrollable="examples"]');
        centerAlignScrollableElement('[data-scrollable="examples"]')
    }

    getDefaultTrackingData(node) {
        const globalTrackParams = global.trackParams || {};
        const parent = findParentByAttribute(node, 'data-trackable-section');
        const sectionId = parent ? parent.getAttribute('data-trackable-section') : null;

        return Object.assign(global.trackParams, {
            section_id: sectionId,
        });
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/LogoDesignInspiration.js